import { render, staticRenderFns } from "./InventoryAssignPlate.vue?vue&type=template&id=0cfc44c8&"
import script from "./InventoryAssignPlate.vue?vue&type=script&lang=js&"
export * from "./InventoryAssignPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports